import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    translation: {
      // Filters (Contracts days filter helpers)
      'filters.timePlaceholder': 'Birim',
      'filters.opPlaceholder': 'Op',
      'filters.unit.day': 'gün',
      'filters.unit.week': 'hafta',
      'filters.unit.month': 'ay',
      'filters.unit.year': 'yıl',
      'filters.op.equals': 'eşit',
      'filters.op.lt': 'küçük',
      'filters.op.lte': 'küçük eşit',
      'filters.op.gt': 'büyük',
      'filters.op.gte': 'büyük eşit',
      // Navigation
      'nav.dashboard': 'Ana Sayfa',
      'nav.customers': 'Müşteriler',
      'nav.contracts': 'Sözleşmeler',
      'nav.companies': 'Şirketler',
      'nav.settings': 'Ayarlar',
      'nav.allContracts': 'Tüm Sözleşmeler',
      'nav.addNewContract': 'Yeni Sözleşme Ekle',
      'nav.contractSettings': 'Sözleşme Ayarları',
      'nav.applicationSettings': 'Uygulama Ayarları',
      'nav.support': 'Support',
      'nav.logout': 'Çıkış',
      
      // Auth
      'auth.login': 'Giriş Yap',
      'auth.register': 'Kayıt Ol',
      'auth.email': 'E-posta',
      'auth.password': 'Şifre',
      'auth.fullName': 'Ad Soyad',
      'auth.welcome': 'Hoş Geldiniz',
      'auth.loginTitle': 'Hesabınıza giriş yapın',
      'auth.registerTitle': 'Yeni hesap oluşturun',
      'auth.noAccount': 'Hesabınız yok mu?',
      'auth.hasAccount': 'Zaten hesabınız var mı?',
      'auth.invalidEmail': 'Geçerli bir e-posta adresi girin',
      'auth.passwordMin': 'Şifre en az 6 karakter olmalı',
      'auth.nameMin': 'Ad soyad en az 2 karakter olmalı',
      'auth.loginSuccess': 'Giriş başarılı!',
      'auth.loginError': 'Giriş başarısız',
      'auth.registerSuccess': 'Kayıt başarılı!',
      'auth.registerError': 'Kayıt başarısız',
      'auth.appSubtitle': 'Sözleşme Yönetim Sistemi',
      'auth.heroTitle': 'Sözleşmelerinizi\nprofesyonelce yönetin',
      'auth.heroDescription': 'Müşteri ilişkilerinizi güçlendirin, sözleşmelerinizi takip edin ve iş süreçlerinizi optimize edin.',
      'auth.registerHeroTitle': 'Hemen başlayın,\nücretsiz kayıt olun',
      'auth.registerHeroDescription': 'Dakikalar içinde hesabınızı oluşturun ve sözleşmelerinizi yönetmeye başlayın.',
      'auth.emailPlaceholder': 'örnek@email.com',
      'auth.passwordPlaceholder': '******',
      'auth.passwordPlaceholder': '******',
      'auth.fullNamePlaceholder': 'Ahmet Yılmaz',
      'auth.loginSubtitle': 'Tekrar hoş geldiniz, lütfen hesabınıza giriş yapın!',
      'auth.rememberMe': 'Beni Hatırla',
      'auth.forgotPassword': 'Şifremi Unuttum',
      'auth.invalidCredentials': 'Geçersiz e-posta veya şifre',
      'auth.invalidToken': 'Geçersiz veya eksik güvenlik anahtarı.',
      'auth.passwordTooShort': 'Şifre en az 6 karakter olmalıdır.',
      'auth.passwordsDoNotMatch': 'Şifreler eşleşmiyor.',
      'auth.passwordResetSuccess': 'Şifreniz başarıyla güncellendi!',
      'auth.invalidLink': 'Geçersiz Bağlantı',
      'auth.invalidLinkSubtitle': 'Şifre sıfırlama bağlantısı geçersiz veya süresi dolmuş.',
      'auth.getNewLink': 'Yeni Bağlantı İste',
      'auth.resetPassword': 'Yeni Şifre Belirle',
      'auth.resetPasswordSubtitle': 'Lütfen yeni şifrenizi giriniz.',
      'auth.newPassword': 'Yeni Şifre',
      'auth.confirmPassword': 'Şifre Tekrar',
      'auth.resetMailSentFeedback': 'şifre sıfırlama maili gönderildi',
      'auth.userNotFound': 'Girmiş olduğunuz bilgilere ait kullanıcı bulunamadı',
      'auth.passwordRequirements': 'Şifre en az 8 karakter, bir büyük harf, bir küçük harf ve bir özel karakter içermelidir.',
      'auth.passwordUppercaseError': 'Şifre en az bir büyük harf içermelidir.',
      'auth.passwordLowercaseError': 'Şifre en az bir küçük harf içermelidir.',
      'auth.passwordSpecialError': 'Şifre en az bir özel karakter içermelidir.',
      'auth.passwordMinLengthError': 'Şifre en az 8 karakter olmalıdır.',
      'auth.brandName': 'Contract Manager',
      'auth.brandFooter': 'ZeuZ-IT tarafından sevgiyle yapıldı',

      // Common
      'common.loading': 'Yükleniyor...',
      'common.save': 'Şifreyi Güncelle',
      'common.send': 'Gönder',
      
      // Dashboard
      'dashboard.title': 'Kontrol Paneli',
      'dashboard.totalContracts': 'Toplam Sözleşme',
      'dashboard.activeCustomers': 'Aktif Müşteri',
      'dashboard.totalCompanies': 'Toplam Şirket',
      'dashboard.contractTypes': 'Sözleşme Tipi',
      'dashboard.expiringSoon': 'Yaklaşan Bitiş',
      'dashboard.totalValue': 'Toplam Değer',
      'dashboard.criticalContracts': 'Kritik Sözleşmeler',
      'dashboard.todoList': 'Yapılacaklar',
      'dashboard.calendar': 'Takvim',
      'dashboard.daysLeft': 'gün kaldı',
      'dashboard.expired': 'Süresi doldu',
      'dashboard.loadError': 'Veri yüklenirken hata oluştu',
      'dashboard.todoAdded': 'Görev eklendi',
      'dashboard.todoAddError': 'Görev eklenemedi',
      'dashboard.todoUpdateError': 'Görev güncellenemedi',
      'dashboard.todoDeleted': 'Görev silindi',
      'dashboard.todoDeleteError': 'Görev silinemedi',
      'dashboard.noTodos': 'Gösterilecek görev yok',
      'dashboard.todoPrompt': 'Yeni görev girin:',
      'dashboard.addNewTodo': 'Yeni Görev Ekle',
      'dashboard.addTodoForDate': '{{date}} için görev ekle',
      'dashboard.todoTitlePlaceholder': 'Görev başlığı',
      'dashboard.todoDescriptionPlaceholder': 'Açıklama',
      'dashboard.markCompleted': 'Tamamlandı olarak işaretle',
      'dashboard.todoUpdated': 'Görev güncellendi',
      'dashboard.todayReminderTitle': 'Bugünkü görevlerin',
      'dashboard.todayReminderCount': '{{count}} görev bekliyor',
      'dashboard.todayReminderAllDone': 'Bugün için tüm görevler tamamlandı',
      'dashboard.todayReminderMore': '+{{count}} daha',
      'dashboard.detail': 'Detay',
      'dashboard.noCriticalContracts': 'Henüz sözleşme yok',
      'dashboard.daysLeftCount': '{{count}} Gün',
      
      // Customers
      'customers.title': 'Müşteriler',
      'customers.totalCount': '{{count}} müşteri kayıtlı',
      'customers.addNew': 'Yeni Müşteri',
      'customers.stats.total': 'Toplam Müşteri',
      'customers.stats.withActiveContract': 'Aktif Sözleşmeli',
      'customers.stats.withoutContract': 'Sözleşmesiz',
      'customers.stats.newThisMonth': 'Bu Ay Eklenen',
      'customers.stats.byCompany': 'Firmaya göre sözleşmeler',
      'customers.stats.byType': 'Sözleşme tipine göre sözleşmeler',
      'customers.stats.activeContractsNote': 'Aktif sözleşme sayıları',
      'customers.stats.empty': 'Henüz sözleşme yok',
      'customers.stats.showAll': 'Tümünü göster (+{{count}})',
      'customers.stats.showLess': 'Daha az göster',
      'customers.firstName': 'Ad',
      'customers.lastName': 'Soyad',
      'customers.email': 'E-posta',
      'customers.phone': 'Telefon',
      'customers.address': 'Adres',
      'customers.company': 'Şirket',
      'customers.search': 'Müşteri ara...',
      'customers.noCustomers': 'Henüz müşteri yok',
      'customers.contracts': 'Sözleşmeler',
      'customers.noEmail': 'E-posta yok',
      'customers.noPhone': 'Telefon Yok',
      'customers.deleteTitle': 'Emin misiniz?',
      'customers.deleteConfirmIntro': 'Şu müşteriyi silmek istediğinize emin misiniz: ',
      'customers.deleteConfirmWith': ' ve buna bağlı ',
      'customers.deleteConfirmContracts': ' sözleşmesini?',
      'customers.firstNameRequired': 'Ad zorunludur',
      'customers.lastNameRequired': 'Soyad zorunludur',
      'customers.birthDateRequired': 'Doğum tarihi zorunludur',
      'customers.addressRequired': 'Adres zorunludur',
      'customers.zipCodeRequired': 'Posta kodu zorunludur',
      'customers.zipCodeNumeric': 'Posta kodu sadece sayılardan oluşmalıdır',
      'customers.invalidEmail': 'Geçerli bir e-posta adresi giriniz',
      'customers.invalidPhone': 'Telefon numarası "+" ve ülke kodu ile başlamalıdır (örn. +90...)',
      'customers.emailRequired': 'E-posta zorunludur (veya "E-posta yok" seçeneğini işaretleyin)',
      'customers.phoneRequired': 'Telefon zorunludur (veya "Telefon yok" seçeneğini işaretleyin)',
      'customers.loadError': 'Müşteriler yüklenirken hata oluştu',
      'customers.addSuccess': 'Müşteri başarıyla eklendi',
      'customers.updateSuccess': 'Müşteri başarıyla güncellendi',
      'customers.deleteSuccess': 'Müşteri başarıyla silindi',
      'customers.deleteError': 'Müşteri silinirken hata oluştu',
      
      // Common
      'auth.backToLogin': 'Giriş Ekranına Dön',
      'auth.resetLinkSent': 'Şifre sıfırlama bağlantısı gönderildi!',
      'auth.forgotPasswordSubtitle': 'Şifrenizi sıfırlamak için e-posta adresinizi giriniz.',

      // Common
      'common.operationFailed': 'İşlem başarısız',
      'common.send': 'Gönder',
      'contracts.title': 'Sözleşmeler',
      'contracts.addNew': 'Yeni Sözleşme',
      'contracts.contractTitle': 'Sözleşme Başlığı',
      'contracts.description': 'Açıklama',
      'contracts.startDate': 'Başlangıç Tarihi',
      'contracts.endDate': 'Bitiş Tarihi',
      'contracts.value': 'Değer',
      'contracts.status': 'Durum',
      'contracts.customer': 'Müşteri',
      'contracts.company': 'Şirket',
      'contracts.type': 'Sözleşme Tipi',
      'contracts.files': 'Dosyalar',
      'contracts.uploadFile': 'Dosya Yükle',
      'contracts.export': 'Dışa Aktar',
      'contracts.filter': 'Filtrele',
      'contracts.search': 'Sözleşme ara...',
      'contracts.noContracts': 'Henüz sözleşme yok',
      'contracts.active': 'Aktif',
      'contracts.expired': 'Süresi Dolmuş',
      'contracts.finishedContract': 'Bitmiş Sözleşme',
      'contracts.extensionMonths': '{{count}} ay',
      'contracts.extensionMonths_plural': '{{count}} ay',
      'contracts.extensionYears': '{{count}} yıl',
      'contracts.extensionYears_plural': '{{count}} yıl',
      'contracts.cancelled': 'İptal Edildi',
      'contracts.daysRemaining': 'Kalan Gün',
      'contracts.manage': 'Sözleşmeleri yönet',
      'contracts.recordsFound': '{{count}} Kayıt Bulundu',
      'contracts.totalRecords': 'Toplam {{count}} Kayıt',
      'contracts.totalRecords': 'Toplam {{count}} Kayıt',
      'contracts.includeExpired': 'Süresi Dolanları Dahil Et',
      'contracts.showExtended': 'Uzatılanları Göster',
      'contracts.orderNo': 'Sipariş No',
      'contracts.orderNumberExists': 'Bu sipariş numarası zaten mevcut',
      'contracts.contractNo': 'Sözleşme No',
      'contracts.contractNumberExists': 'Bu sözleşme numarası zaten mevcut',
      'contracts.deleteModalTitle': 'Emin misiniz?',
      'contracts.deleteModalMessage': 'Bu sözleşmeyi silmek istediğinize emin misiniz: ',
      'contracts.perPage': 'Sayfa Başına',
      'contracts.showRecords': 'Kayıt Göster',
      'contracts.prev': 'Önceki',
      'contracts.next': 'Sonraki',
      'contracts.deleteConfirm': 'Bu sözleşmeyi silmek istediğinizden emin misiniz?',
      'contracts.deleteSuccess': 'Sözleşme silindi',
      'contracts.deleteError': 'Sözleşme silinemedi',
      'contracts.loadError': 'Veri yüklenirken hata oluştu',
      'contracts.detailLoadError': 'Sözleşme detayları yüklenemedi',
      'contracts.exportSuccess': 'Dosya indirildi',
      'contracts.exportError': 'Dışa aktarma başarısız',
      'contracts.overdue': '{{days}} gün gecikmiş',
      'contracts.print': 'Yazdır',
      'contracts.days': 'gün',
      'contracts.addContract': 'Sözleşme Ekle',
      'contracts.clearFilter': 'Filtre Temizle',
      'contracts.info': 'Bilgi',
      'contracts.detailTitle': 'Sözleşme Detayı',
      'contracts.history': 'Sözleşme Geçmişi',
      'contracts.noHistory': 'Sözleşmeye ait uzatma bilgisi bulunamadı.',
      'contracts.contractFiles': 'Sözleşme Dosyaları',
      'contracts.editTitle': 'Sözleşme Bilgilerini Güncelle',
      'contracts.selectContractType': 'Öncelikle Bir Sözleşme Türü Seçiniz',
      'contracts.selectCompanyLabel': 'Şirket Seç',
      'contracts.extendDate': 'Sözleşme Bitiş Tarihini Uzat',
      'contracts.6months': '+6 Ay',
      'contracts.1year': '+1 Yıl',
      'contracts.2years': '+2 Yıl',
      'contracts.contractNoPlaceholder': 'Sözleşme No Girilmemiş',
      'contracts.descriptionOptional': 'Açıklama(Opsiyonel)',
      'contracts.filesOptional': 'Sözleşme Dosyaları(Opsiyonel)',
      'contracts.removeFile': 'Dosyayı Kaldır',
      'contracts.update': 'Güncelle',
      'contracts.close': 'Kapat',
      'contracts.noFilesUploaded': 'Yüklenmiş dosya bulunamadı',
      
      'wizard.step1': 'Müşteri Seç',
      'wizard.step2': 'Sözleşme Bilgileri',
      'wizard.step3': 'Sözleşme Dosyaları',
      'wizard.back': 'Önceki',
      'wizard.next': 'Sonraki',
      'wizard.send': 'Gönder',
      'wizard.cancel': 'İptal',
      'wizard.searchPlaceholder': 'Müşteri Ara',
      'wizard.addNewCustomer': 'Yeni Müşteri Ekle',
      'wizard.noCustomers': 'Müşteri bulunamadı',
      'wizard.selectedCustomer': 'Seçili Müşteri:',
      'wizard.fillRequiredFields': 'Lütfen boş alanları doldurunuz',
      
      'customer.addTitle': 'Yeni Müşteri Ekle',
      'customer.firstName': 'Ad',
      'customer.lastName': 'Soyad',
      'customer.email': 'E-mail',
      'customer.phone': 'Telefon',
      'customer.birthDate': 'Doğum Tarihi',
      'customer.address': 'Adres',
      'customer.postalCode': 'Posta Kodu',
      'customer.addBtn': 'Ekle',
      'customer.added': 'Müşteri eklendi',
      'customer.addError': 'Müşteri eklenirken hata oluştu',

      'contract.title': 'Sözleşme Başlığı',
      'contract.type': 'Sözleşme Türü',
      'contract.company': 'Şirket Seç',
      'contract.startDate': 'Başlangıç Tarihi',
      'contract.endDate': 'Bitiş Tarihi',
      'contract.duration': 'Sözleşme Süresi',
      'contract.orderNo': 'Sipariş No',
      'contract.contractNo': 'Sözleşme No',
      'contract.description': 'Açıklama(Opsiyonel)',
      'contract.dragDrop': 'Dosyaları Buraya Sürükleyin veya Yüklemek için Tıklayın.',
      'contract.supportedFormats': '(Desteklenen dosya formatları: Excel,Word,Resimler ve Pdf)',
      'contract.maxSize': '(İzin verilen maksimum dosya boyutu: 256 MB.)',
      'contract.createSuccess': 'Sözleşme başarıyla oluşturuldu',
      'contract.dateError': 'Bitiş tarihi başlangıç tarihinden sonra olmalı',
      'contract.selectCustomerError': 'Lütfen bir müşteri seçiniz',
      
      // Companies
      'companies.title': 'Şirketler',
      'companies.addNew': 'Yeni Şirket',
      'companies.name': 'Şirket Adı',
      'companies.address': 'Adres',
      'companies.phone': 'Telefon',
      'companies.email': 'E-posta',
      
      // Contract Types
      'contractTypes.title': 'Sözleşme Tipleri',
      'contractTypes.addNew': 'Yeni Tip',
      'contractTypes.name': 'Tip Adı',
      'contractTypes.description': 'Açıklama',
      
      // Common
      'common.save': 'Kaydet',
      'common.cancel': 'İptal',
      'common.delete': 'Sil',
      'common.edit': 'Düzenle',
      'common.view': 'Görüntüle',
      'common.update': 'Güncelle',
      'common.actions': 'İşlemler',
      'common.loading': 'Yükleniyor...',
      'common.error': 'Hata',
      'common.success': 'Başarılı',
      'common.confirm': 'Onayla',
      'common.close': 'Kapat',
      'common.add': 'Ekle',
      // Settings (generic)
      'settings.subtitle': 'Şirketleri ve sözleşme türlerini yönetin',
      'settings.loadError': 'Veri yüklenirken hata oluştu',
      'settings.operationFailed': 'İşlem başarısız',
      'settings.confirmDeleteCompany': 'Bu şirketi silmek istediğinizden emin misiniz?',
      'settings.confirmDeleteContractType': 'Bu sözleşme türünü silmek istediğinizden emin misiniz?',
      'settings.companyUpdated': 'Şirket güncellendi',
      'settings.companyAdded': 'Şirket eklendi',
      'settings.companyDeleted': 'Şirket silindi',
      'settings.companyDeleteError': 'Şirket silinemedi',
      'settings.contractTypeUpdated': 'Sözleşme türü güncellendi',
      'settings.contractTypeAdded': 'Sözleşme türü eklendi',
      'settings.contractTypeDeleted': 'Sözleşme türü silindi',
      'settings.contractTypeDeleteError': 'Sözleşme türü silinemedi',
      'settings.companiesTab': 'Şirketler',
      'settings.contractTypesTab': 'Sözleşme Türleri',
      'settings.newCompany': 'Yeni Şirket',
      'settings.addNewType': 'Yeni Tür Ekle',
      'settings.addNewCompany': 'Yeni Şirket Ekle',
      'settings.addNewContractType': 'Yeni Sözleşme Türü Ekle',
      'settings.editCompany': 'Şirketi Düzenle',
      'settings.editContractType': 'Sözleşme Türünü Düzenle',
      'settings.companyName': 'Şirket Adı',
      'settings.email': 'E-posta',
      'settings.phone': 'Telefon',
      'settings.address': 'Adres',
      'settings.actions': 'İşlemler',
      'settings.typeName': 'Tür Adı',
      'settings.contractTypeName': 'Sözleşme Türü Adı',
      'settings.description': 'Açıklama',
      'settings.noCompaniesYet': 'Henüz şirket yok',
      'settings.noContractTypesYet': 'Henüz sözleşme türü yok',
      'settings.searchPlaceholder': 'Ara...',
      'settings.id': 'Id',
      'settings.contractType': 'Sözleşme Türü',
      'settings.contractCount': 'Sözleşme Sayısı',
      'settings.noRecordsYet': 'Henüz kayıt yok',
      'settings.active': 'Aktif',
      'settings.selectCompany': 'Şirket Seç',
      'settings.selectCompanyPlaceholder': 'Şirket seç',
      'settings.selectContractType': 'Sözleşme türü seç',
      'settings.noContractTypesFound': 'Sözleşme türü bulunamadı',
      'settings.newCompanyNamePlaceholder': 'Yeni Şirket Adı',
      'settings.newContractTypeNamePlaceholder': 'Yeni Sözleşme Türü Adı',
      'settings.contractTypeRequired': 'Sözleşme türü zorunludur',
      'settings.contractSettingsTitle': 'Sözleşme Ayarları',
      'settings.contractSettingsTotalRows': 'Toplam {{count}} Satır',

      // Application Settings
      'appSettings.title': 'Uygulama Ayarları',
      'appSettings.subtitle': 'Genel uygulama ayarları',
      'appSettings.loadError': 'Ayarlar yüklenemedi',
      'appSettings.saveSuccess': 'Ayarlar kaydedildi',
      'appSettings.saveError': 'Ayarlar kaydedilemedi',
      'appSettings.resetSuccess': 'Ayarlar varsayılana döndürüldü',
      'appSettings.resetError': 'Sıfırlama başarısız',
      'appSettings.backupDownloaded': 'Yedek indirildi',
      'appSettings.contractEndReminder': 'Sözleşme Bitiş Hatırlatması',
      'appSettings.contractEndReminderOptions.one_day': 'Bir Günden Az Kalanları Mail Gönder',
      'appSettings.contractEndReminderOptions.one_week': 'Bir Haftadan Az Kalanları Mail Gönder',
      'appSettings.contractEndReminderOptions.one_month': 'Bir Aydan Az Kalanları Mail Gönder',
      'appSettings.contractEndReminderOptions.three_months': 'Üç Aydan Az Kalanları Mail Gönder',
      'appSettings.contractEndReminderOptions.six_months': 'Altı Aydan Az Kalanları Mail Gönder',
      'appSettings.contractEndReminderOptions.one_year': 'Bir Yıldan Az Kalanları Mail Gönder',
      'appSettings.reminderEmailPeriod': 'Hatırlatma E-posta Periyodu',
      'appSettings.backupEmailPeriod': 'Yedekleme E-posta Periyodu',
      'appSettings.periodOptions.daily': 'Günde 1 Defa',
      'appSettings.periodOptions.weekly': 'Haftada 1 Defa',
      'appSettings.periodOptions.monthly': 'Ayda 1 Defa',
      'appSettings.periodOptions.quarterly': '3 Ayda 1 Defa',
      'appSettings.periodOptions.half_yearly': '6 Ayda 1 Defa',
      'appSettings.periodOptions.yearly': 'Senede 1 Defa',
      'appSettings.email': 'E-posta',
      'appSettings.emailPlaceholder': 'info@contractmanager.com',
      'appSettings.email2': '2. E-posta (opsiyonel)',
      'appSettings.email2Placeholder': 'ikinci@email.com',
      'appSettings.sidebar': 'Kenar Çubuğu',
      'appSettings.sidebarOptions.modern': 'Modern',
      'appSettings.sidebarOptions.classic': 'Klasik',
      'appSettings.sidebarOptions.minimal': 'Minimal',
      'appSettings.themeColorLight': 'Tema Rengi (Açık Mod)',
      'appSettings.themeColorDark': 'Tema Rengi (Koyu Mod)',
      'appSettings.resetDefaults': 'Varsayılanlara Sıfırla',
      'appSettings.saveChanges': 'Değişiklikleri Kaydet',
      'appSettings.downloadBackup': 'Yedek İndir',
      'appSettings.downloadBackupDescription': 'Ayarlarınızı ve verilerinizi yedek dosyası olarak dışa aktarın',
      'appSettings.download': 'İndir',
      'appSettings.includeContractFiles': 'Sözleşme dosyalarını da indir (PDF)',
      'appSettings.backupPreparing': 'Yedek hazırlanıyor, lütfen bekleyin… (dosyalar zipleniyor)',
      'appSettings.backupDownloading': 'İndiriliyor',
      'common.details': 'Detaylar',
      'common.all': 'Tümü',
      'common.today': 'Bugün',
      
      // Todos
      'todos.placeholder': 'Yeni görev ekle...',
      'todos.empty': 'Yapılacak görev yok',
    }
  },
  en: {
    translation: {
      // Filters (Contracts days filter helpers)
      'filters.timePlaceholder': 'Time',
      'filters.opPlaceholder': 'Op',
      'filters.unit.day': 'day',
      'filters.unit.week': 'week',
      'filters.unit.month': 'month',
      'filters.unit.year': 'year',
      'filters.op.equals': 'equals',
      'filters.op.lt': 'less',
      'filters.op.lte': 'less equal',
      'filters.op.gt': 'greater',
      'filters.op.gte': 'greater equal',
      // Navigation
      'nav.dashboard': 'Home',
      'nav.customers': 'Customers',
      'nav.contracts': 'Contracts',
      'nav.companies': 'Companies',
      'nav.settings': 'Settings',
      'nav.allContracts': 'All Contracts',
      'nav.addNewContract': 'Add New Contract',
      'nav.contractSettings': 'Contract Settings',
      'nav.applicationSettings': 'Application Settings',
      'nav.support': 'Support',
      'nav.logout': 'Logout',
      
      // Auth
      'auth.login': 'Login',
      'auth.register': 'Register',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.fullName': 'Full Name',
      'auth.welcome': 'Welcome',
      'auth.loginTitle': 'Sign in to your account',
      'auth.registerTitle': 'Create a new account',
      'auth.noAccount': "Don't have an account?",
      'auth.hasAccount': 'Already have an account?',
      'auth.forgotPassword': 'Forgot Password',
      'auth.backToLogin': 'Back to Login',
      'auth.resetLinkSent': 'Password reset link sent!',
      'auth.forgotPasswordSubtitle': 'Enter your email address to reset your password.',
      'auth.invalidEmail': 'Please enter a valid email address',
      'auth.passwordMin': 'Password must be at least 6 characters',
      'auth.nameMin': 'Name must be at least 2 characters',
      'auth.loginSuccess': 'Login successful!',
      'auth.loginError': 'Login failed',
      'auth.registerSuccess': 'Registration successful!',
      'auth.registerError': 'Registration failed',
      'auth.appSubtitle': 'Contract Management System',
      'auth.heroTitle': 'Manage your contracts\nprofessionally',
      'auth.heroDescription': 'Strengthen customer relationships, track your contracts, and optimize your business processes.',
      'auth.registerHeroTitle': 'Start now,\nsign up for free',
      'auth.registerHeroDescription': 'Create your account in minutes and start managing your contracts.',
      'auth.emailPlaceholder': 'example@email.com',
      'auth.passwordPlaceholder': '******',
      'auth.passwordPlaceholder': '******',
      'auth.fullNamePlaceholder': 'John Doe',
      'auth.loginSubtitle': 'Welcome back, please sign in to your account!',
      'auth.rememberMe': 'Remember Me',
      'auth.forgotPassword': 'Forgot Password',
      'auth.invalidCredentials': 'Invalid email or password',
      'auth.invalidToken': 'Invalid or missing security token.',
      'auth.passwordTooShort': 'Password must be at least 6 characters.',
      'auth.passwordsDoNotMatch': 'Passwords do not match.',
      'auth.passwordResetSuccess': 'Your password has been reset successfully!',
      'auth.invalidLink': 'Invalid Link',
      'auth.invalidLinkSubtitle': 'The password reset link is invalid or has expired.',
      'auth.getNewLink': 'Request New Link',
      'auth.resetPassword': 'Set New Password',
      'auth.resetPasswordSubtitle': 'Please enter your new password.',
      'auth.newPassword': 'New Password',
      'auth.confirmPassword': 'Confirm Password',
      'auth.resetMailSentFeedback': 'password reset mail sent',
      'auth.userNotFound': 'User not found with the information provided',
      'auth.passwordRequirements': 'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one special character.',
      'auth.passwordUppercaseError': 'Password must contain at least one uppercase letter.',
      'auth.passwordLowercaseError': 'Password must contain at least one lowercase letter.',
      'auth.passwordSpecialError': 'Password must contain at least one special character.',
      'auth.passwordMinLengthError': 'Password must be at least 8 characters long.',
      'auth.brandName': 'Contract Manager',
      'auth.brandFooter': 'Hand crafted & made by ZeuZ-IT',

      // Common
      'common.loading': 'Loading...',
      'common.save': 'Update Password',
      'common.send': 'Send',
      
      // Dashboard
      'dashboard.title': 'Dashboard',
      'dashboard.totalContracts': 'Total Contracts',
      'dashboard.activeCustomers': 'Active Customers',
      'dashboard.totalCompanies': 'Total Companies',
      'dashboard.contractTypes': 'Contract Types',
      'dashboard.expiringSoon': 'Expiring Soon',
      'dashboard.totalValue': 'Total Value',
      'dashboard.criticalContracts': 'Critical Contracts',
      'dashboard.todoList': 'To-Do List',
      'dashboard.calendar': 'Calendar',
      'dashboard.daysLeft': 'days left',
      'dashboard.expired': 'Expired',
      'dashboard.loadError': 'Error loading data',
      'dashboard.todoAdded': 'Task added',
      'dashboard.todoAddError': 'Could not add task',
      'dashboard.todoUpdateError': 'Could not update task',
      'dashboard.todoDeleted': 'Task deleted',
      'dashboard.todoDeleteError': 'Could not delete task',
      'dashboard.noTodos': 'No tasks to display',
      'dashboard.todoPrompt': 'Enter new task:',
      'dashboard.addNewTodo': 'Add New Task',
      'dashboard.addTodoForDate': 'Add task for {{date}}',
      'dashboard.todoTitlePlaceholder': 'Task title',
      'dashboard.todoDescriptionPlaceholder': 'Description',
      'dashboard.markCompleted': 'Mark as completed',
      'dashboard.todoUpdated': 'Task updated',
      'dashboard.todayReminderTitle': "Today's tasks",
      'dashboard.todayReminderCount': '{{count}} task pending',
      'dashboard.todayReminderCount_plural': '{{count}} tasks pending',
      'dashboard.todayReminderAllDone': 'All tasks for today are completed',
      'dashboard.todayReminderMore': '+{{count}} more',
      'dashboard.detail': 'Detail',
      'dashboard.noCriticalContracts': 'No contracts yet',
      'dashboard.daysLeftCount': '{{count}} Day',
      'dashboard.daysLeftCount_plural': '{{count}} Days',
      
      // Customers
      'customers.title': 'Customers',
      'customers.totalCount': '{{count}} customers registered',
      'customers.addNew': 'New Customer',
      'customers.stats.total': 'Total Customers',
      'customers.stats.withActiveContract': 'With Active Contract',
      'customers.stats.withoutContract': 'Without Contract',
      'customers.stats.newThisMonth': 'Added This Month',
      'customers.stats.byCompany': 'Contracts by company',
      'customers.stats.byType': 'Contracts by contract type',
      'customers.stats.activeContractsNote': 'Active contract counts',
      'customers.stats.empty': 'No contracts yet',
      'customers.stats.showAll': 'Show all (+{{count}})',
      'customers.stats.showLess': 'Show less',
      'customers.firstName': 'First Name',
      'customers.lastName': 'Last Name',
      'customers.email': 'Email',
      'customers.phone': 'Phone',
      'customers.address': 'Address',
      'customers.company': 'Company',
      'customers.search': 'Search customers...',
      'customers.noCustomers': 'No customers yet',
      'customers.contracts': 'Contracts',
      'customers.noEmail': 'No Email',
      'customers.noPhone': 'No Phone',
      'customers.deleteTitle': 'Are you sure?',
      'customers.deleteConfirmIntro': 'Are you sure you want to delete customer ',
      'customers.deleteConfirmWith': ' along with their ',
      'customers.deleteConfirmContracts': ' Contracts?',
      'customers.firstNameRequired': 'First name is required',
      'customers.lastNameRequired': 'Last name is required',
      'customers.birthDateRequired': 'Birth date is required',
      'customers.addressRequired': 'Address is required',
      'customers.zipCodeRequired': 'Postal code is required',
      'customers.zipCodeNumeric': 'Postal code must contain only numbers',
      'customers.invalidEmail': 'Please enter a valid email address',
      'customers.invalidPhone': 'Phone number must start with "+" and country code (e.g. +49...)',
      'customers.emailRequired': 'Email is required (or enable "No Email")',
      'customers.phoneRequired': 'Phone is required (or enable "No Phone Number")',
      'customers.loadError': 'Error loading customers',
      'customers.addSuccess': 'Customer added successfully',
      'customers.updateSuccess': 'Customer updated successfully',
      'customers.deleteSuccess': 'Customer deleted successfully',
      'customers.deleteError': 'Could not delete customer',

      // Contracts
      'contracts.title': 'Contracts',
      'contracts.addNew': 'New Contract',
      'contracts.contractTitle': 'Contract Title',
      'contracts.description': 'Description',
      'contracts.startDate': 'Start Date',
      'contracts.endDate': 'End Date',
      'contracts.value': 'Value',
      'contracts.status': 'Status',
      'contracts.customer': 'Customer',
      'contracts.company': 'Company',
      'contracts.type': 'Contract Type',
      'contracts.files': 'Files',
      'contracts.uploadFile': 'Upload File',
      'contracts.export': 'Export',
      'contracts.filter': 'Filter',
      'contracts.search': 'Search contracts...',
      'contracts.noContracts': 'No contracts yet',
      'contracts.active': 'Active',
      'contracts.expired': 'Expired',
      'contracts.finishedContract': 'Expired Contract',
      'contracts.extensionMonths': '{{count}} month',
      'contracts.extensionMonths_plural': '{{count}} months',
      'contracts.extensionYears': '{{count}} year',
      'contracts.extensionYears_plural': '{{count}} years',
      'contracts.cancelled': 'Cancelled',
      'contracts.daysRemaining': 'Days Remaining',
      'contracts.manage': 'Manage contracts',
      'contracts.recordsFound': '{{count}} Records Found',
      'contracts.totalRecords': '({{count}} Records in total)',
      'contracts.includeExpired': 'Include Expired Contracts',
      'contracts.showExtended': 'Show Extended Contracts',
      'contracts.orderNo': 'Order No',
      'contracts.orderNumberExists': 'This order number already exists',
      'contracts.contractNo': 'Contract No',
      'contracts.contractNumberExists': 'This contract number already exists',
      'contracts.deleteModalTitle': 'Are you sure?',
      'contracts.deleteModalMessage': 'Are you sure you want to delete this contract: ',
      'contracts.perPage': 'Per Page',
      'contracts.showRecords': 'Show Records',
      'contracts.prev': 'Prev',
      'contracts.next': 'Next',
      'contracts.deleteConfirm': 'Are you sure you want to delete this contract?',
      'contracts.deleteSuccess': 'Contract deleted',
      'contracts.deleteError': 'Could not delete contract',
      'contracts.loadError': 'Error loading data',
      'contracts.detailLoadError': 'Could not load contract details',
      'contracts.exportSuccess': 'File downloaded',
      'contracts.exportError': 'Export failed',
      'contracts.overdue': '{{days}} days overdue',
      'contracts.print': 'Print',
      'contracts.days': 'days',
      'contracts.addContract': 'Add Contract',
      'contracts.clearFilter': 'Clear Filter',
      'contracts.info': 'Info',
      'contracts.detailTitle': 'Contract Details',
      'contracts.history': 'Contract History',
      'contracts.noHistory': 'No extension information found for the contract.',
      'contracts.contractFiles': 'Contract Files',
      'contracts.editTitle': 'Update Contract Information',
      'contracts.selectContractType': 'Select a Contract Type First',
      'contracts.selectCompanyLabel': 'Select Company',
      'contracts.extendDate': 'Extend Contract End Date',
      'contracts.6months': '+6 Months',
      'contracts.1year': '+1 Year',
      'contracts.2years': '+2 Years',
      'contracts.contractNoPlaceholder': 'Contract No Not Entered',
      'contracts.descriptionOptional': 'Description (Optional)',
      'contracts.filesOptional': 'Contract Files (Optional)',
      'contracts.removeFile': 'Remove File',
      'contracts.update': 'Update',
      'contracts.close': 'Close',
      'contracts.noFilesUploaded': 'No files uploaded',
      
      'wizard.step1': 'Select Customer',
      'wizard.step2': 'Contract Info',
      'wizard.step3': 'Contract Files',
      'wizard.back': 'Back',
      'wizard.next': 'Next',
      'wizard.send': 'Submit',
      'wizard.cancel': 'Cancel',
      'wizard.searchPlaceholder': 'Search Customer',
      'wizard.addNewCustomer': 'Add New Customer',
      'wizard.noCustomers': 'No customers found',
      'wizard.selectedCustomer': 'Selected Customer:',
      'wizard.fillRequiredFields': 'Please fill in the required fields',

      'customer.addTitle': 'Add New Customer',
      'customer.firstName': 'First Name',
      'customer.lastName': 'Last Name',
      'customer.email': 'Email',
      'customer.phone': 'Phone',
      'customer.birthDate': 'Date of Birth',
      'customer.address': 'Address',
      'customer.postalCode': 'Postal Code',
      'customer.addBtn': 'Add',
      'customer.added': 'Customer added',
      'customer.addError': 'Error adding customer',

      'contract.title': 'Contract Title',
      'contract.type': 'Contract Type',
      'contract.company': 'Select Company',
      'contract.startDate': 'Start Date',
      'contract.endDate': 'End Date',
      'contract.duration': 'Contract Duration',
      'contract.orderNo': 'Order No',
      'contract.contractNo': 'Contract No',
      'contract.description': 'Description (Optional)',
      'contract.dragDrop': 'Drag Files Here or Click to Upload.',
      'contract.supportedFormats': '(Supported formats: Excel,Word,Images and Pdf)',
      'contract.maxSize': '(Max file size: 256 MB.)',
      'contract.createSuccess': 'Contract created successfully',
      'contract.dateError': 'End date must be after start date',
      'contract.selectCustomerError': 'Please select a customer',
      
      // Wizard steps
      'wizard.duration': 'Duration',
      'wizard.6months': '+6 Months',
      'wizard.1year': '+1 Year',
      'wizard.2years': '+2 Years',
      
      // Companies
      'companies.title': 'Companies',
      'companies.addNew': 'New Company',
      'companies.name': 'Company Name',
      'companies.address': 'Address',
      'companies.phone': 'Phone',
      'companies.email': 'Email',
      
      // Contract Types
      'contractTypes.title': 'Contract Types',
      'contractTypes.addNew': 'New Type',
      'contractTypes.name': 'Type Name',
      'contractTypes.description': 'Description',
      
      // Common
      'common.save': 'Save',
      'common.cancel': 'Cancel',
      'common.delete': 'Delete',
      'common.edit': 'Edit',
      'common.view': 'View',
      'common.update': 'Update',
      'common.actions': 'Actions',
      'common.loading': 'Loading...',
      'common.error': 'Error',
      'common.success': 'Success',
      'common.confirm': 'Confirm',
      'common.close': 'Close',
      'common.add': 'Add',
      // Settings (generic)
      'settings.subtitle': 'Manage companies and contract types',
      'settings.loadError': 'Error loading data',
      'settings.operationFailed': 'Operation failed',
      'settings.confirmDeleteCompany': 'Are you sure you want to delete this company?',
      'settings.confirmDeleteContractType': 'Are you sure you want to delete this contract type?',
      'settings.companyUpdated': 'Company updated',
      'settings.companyAdded': 'Company added',
      'settings.companyDeleted': 'Company deleted',
      'settings.companyDeleteError': 'Could not delete company',
      'settings.contractTypeUpdated': 'Contract type updated',
      'settings.contractTypeAdded': 'Contract type added',
      'settings.contractTypeDeleted': 'Contract type deleted',
      'settings.contractTypeDeleteError': 'Could not delete contract type',
      'settings.companiesTab': 'Companies',
      'settings.contractTypesTab': 'Contract Types',
      'settings.newCompany': 'New Company',
      'settings.addNewType': 'Add New Type',
      'settings.addNewCompany': 'Add New Company',
      'settings.addNewContractType': 'Add New Contract Type',
      'settings.editCompany': 'Edit Company',
      'settings.editContractType': 'Edit Contract Type',
      'settings.companyName': 'Company Name',
      'settings.email': 'Email',
      'settings.phone': 'Phone',
      'settings.address': 'Address',
      'settings.actions': 'Actions',
      'settings.typeName': 'Type Name',
      'settings.contractTypeName': 'Contract Type Name',
      'settings.description': 'Description',
      'settings.noCompaniesYet': 'No companies yet',
      'settings.noContractTypesYet': 'No contract types yet',
      'settings.searchPlaceholder': 'Search...',
      'settings.id': 'Id',
      'settings.contractType': 'Contract Type',
      'settings.contractCount': 'Contract Count',
      'settings.noRecordsYet': 'No records yet',
      'settings.active': 'Active',
      'settings.selectCompany': 'Select Company',
      'settings.selectCompanyPlaceholder': 'Select company',
      'settings.selectContractType': 'Select contract type',
      'settings.noContractTypesFound': 'No contract types found',
      'settings.newCompanyNamePlaceholder': 'New Company Name',
      'settings.newContractTypeNamePlaceholder': 'New Contract Type Name',
      'settings.contractTypeRequired': 'Contract type is required',
      'settings.contractSettingsTitle': 'Contract Settings',
      'settings.contractSettingsTotalRows': 'Total {{count}} Rows',

      // Application Settings
      'appSettings.title': 'Application Settings',
      'appSettings.subtitle': 'General application settings',
      'appSettings.loadError': 'Failed to load settings',
      'appSettings.saveSuccess': 'Settings saved successfully',
      'appSettings.saveError': 'Failed to save settings',
      'appSettings.resetSuccess': 'Settings reset to defaults',
      'appSettings.resetError': 'Failed to reset settings',
      'appSettings.backupDownloaded': 'Backup downloaded',
      'appSettings.contractEndReminder': 'Contract End Reminder',
      'appSettings.contractEndReminderOptions.one_day': 'Send mail for contracts ending in 1 day',
      'appSettings.contractEndReminderOptions.one_week': 'Send mail for contracts ending in 1 week',
      'appSettings.contractEndReminderOptions.one_month': 'Send mail for contracts ending in 1 month',
      'appSettings.contractEndReminderOptions.three_months': 'Send mail for contracts ending in 3 months',
      'appSettings.contractEndReminderOptions.six_months': 'Send mail for contracts ending in 6 months',
      'appSettings.contractEndReminderOptions.one_year': 'Send mail for contracts ending in 1 year',
      'appSettings.reminderEmailPeriod': 'Reminder Email Period',
      'appSettings.backupEmailPeriod': 'Backup Email Period',
      'appSettings.periodOptions.daily': 'Once a day',
      'appSettings.periodOptions.weekly': 'Once a week',
      'appSettings.periodOptions.monthly': 'Once a month',
      'appSettings.periodOptions.quarterly': 'Once every 3 months',
      'appSettings.periodOptions.half_yearly': 'Once every 6 months',
      'appSettings.periodOptions.yearly': 'Once a year',
      'appSettings.email': 'E-mail',
      'appSettings.emailPlaceholder': 'info@contractmanager.com',
      'appSettings.email2': 'Second e-mail (optional)',
      'appSettings.email2Placeholder': 'second@email.com',
      'appSettings.sidebar': 'Sidebar',
      'appSettings.sidebarOptions.modern': 'Modern Sidebar',
      'appSettings.sidebarOptions.classic': 'Classic Sidebar',
      'appSettings.sidebarOptions.minimal': 'Minimal Sidebar',
      'appSettings.themeColorLight': 'Theme Color (Light Mode)',
      'appSettings.themeColorDark': 'Theme Color (Dark Mode)',
      'appSettings.resetDefaults': 'Reset to Defaults',
      'appSettings.saveChanges': 'Save Changes',
      'appSettings.downloadBackup': 'Download Backup',
      'appSettings.downloadBackupDescription': 'Export your settings and data as a backup file',
      'appSettings.download': 'Download',
      'appSettings.includeContractFiles': 'Also download contract files (PDF)',
      'appSettings.backupPreparing': 'Preparing backup, please wait… (zipping files)',
      'appSettings.backupDownloading': 'Downloading',
      'common.details': 'Details',
      'common.all': 'All',
      'common.today': 'Today',
      
      // Todos
      'todos.placeholder': 'Add new task...',
      'todos.empty': 'No tasks yet',
    }
  },
  de: {
    translation: {
      // Filters (Contracts days filter helpers)
      'filters.timePlaceholder': 'Einheit',
      'filters.opPlaceholder': 'Op',
      'filters.unit.day': 'tag',
      'filters.unit.week': 'woche',
      'filters.unit.month': 'monat',
      'filters.unit.year': 'jahr',
      'filters.op.equals': 'gleich',
      'filters.op.lt': 'kleiner',
      'filters.op.lte': 'kleiner gleich',
      'filters.op.gt': 'größer',
      'filters.op.gte': 'größer gleich',
      // Navigation
      'nav.dashboard': 'Startseite',
      'nav.customers': 'Kunden',
      'nav.contracts': 'Verträge',
      'nav.companies': 'Firmen',
      'nav.settings': 'Einstellungen',
      'nav.allContracts': 'Alle Verträge',
      'nav.addNewContract': 'Neuen Vertrag hinzufügen',
      'nav.contractSettings': 'Vertragseinstellungen',
      'nav.applicationSettings': 'Anwendungseinstellungen',
      'nav.support': 'Support',
      'nav.logout': 'Abmelden',
      
      // Auth
      'auth.register': 'Registrieren',
      'auth.forgotPassword': 'Passwort vergessen',
      'auth.backToLogin': 'Zurück zum Login',
      'auth.resetLinkSent': 'Link zum Zurücksetzen des Passworts gesendet!',
      'auth.forgotPasswordSubtitle': 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.',
      'auth.email': 'E-Mail',
      'auth.password': 'Passwort',
      'auth.fullName': 'Vollständiger Name',
      'auth.welcome': 'Willkommen',
      'auth.loginTitle': 'In Ihr Konto einloggen',
      'auth.loginSubtitle': 'Willkommen zurück, melden sie sich bei ihrem konto an!',
      'auth.registerTitle': 'Neues Konto erstellen',
      'auth.noAccount': 'Kein Profil?',
      'auth.hasAccount': 'Bereits ein Konto?',
      'auth.rememberMe': 'Passwort Merken',
      'auth.forgotPassword': 'Passwort vergessen',
      'auth.emailPlaceholder': 'sie@unternehmen.de',
      'auth.invalidCredentials': 'Ungültige E-Mail oder Passwort',
      'auth.invalidToken': 'Ungültiger oder fehlender Sicherheitstoken.',
      'auth.passwordTooShort': 'Das Passwort muss mindestens 6 Zeichen lang sein.',
      'auth.passwordsDoNotMatch': 'Passwörter stimmen nicht überein.',
      'auth.passwordResetSuccess': 'Ihr Passwort wurde erfolgreich zurückgesetzt!',
      'auth.invalidLink': 'Ungültiger Link',
      'auth.invalidLinkSubtitle': 'Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen.',
      'auth.getNewLink': 'Neuen Link anfordern',
      'auth.resetPassword': 'Neues Passwort festlegen',
      'auth.resetPasswordSubtitle': 'Bitte geben Sie Ihr neues Passwort ein.',
      'auth.newPassword': 'Neues Passwort',
      'auth.confirmPassword': 'Passwort bestätigen',
      'auth.resetMailSentFeedback': 'Passwort-Rücksetz-E-Mail gesendet',
      'auth.userNotFound': 'Benutzer mit den angegebenen Informationen nicht gefunden',
      'auth.passwordRequirements': 'Das Passwort muss mindestens 8 Zeichen lang sein und einen Großbuchstaben, einen Kleinbuchstaben und ein Sonderzeichen enthalten.',
      'auth.passwordUppercaseError': 'Das Passwort muss mindestens einen Großbuchstaben enthalten.',
      'auth.passwordLowercaseError': 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten.',
      'auth.passwordSpecialError': 'Das Passwort muss mindestens ein Sonderzeichen enthalten.',
      'auth.passwordMinLengthError': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
      'auth.brandName': 'Contract Manager',
      'auth.brandFooter': 'Handgefertigt & erstellt von ZeuZ-IT',

      // Common
      'common.loading': 'Laden...',
      'common.save': 'Passwort aktualisieren',
      'common.send': 'Senden',
      'dashboard.title': 'Dashboard',
      'dashboard.totalContracts': 'Gesamtverträge',
      'dashboard.activeCustomers': 'Aktive Kunden',
      'dashboard.totalCompanies': 'Gesamtfirmen',
      'dashboard.contractTypes': 'Vertragstypen',
      'dashboard.expiringSoon': 'Läuft bald ab',
      'dashboard.totalValue': 'Gesamtwert',
      'dashboard.criticalContracts': 'Kritische Verträge',
      'dashboard.todoList': 'Aufgabenliste',
      'dashboard.calendar': 'Kalender',
      'dashboard.daysLeft': 'Tage übrig',
      'dashboard.expired': 'Abgelaufen',
      'dashboard.loadError': 'Fehler beim Laden der Daten',
      'dashboard.todoAdded': 'Aufgabe hinzugefügt',
      'dashboard.todoAddError': 'Aufgabe konnte nicht hinzugefügt werden',
      'dashboard.todoUpdateError': 'Aufgabe konnte nicht aktualisiert werden',
      'dashboard.todoDeleted': 'Aufgabe gelöscht',
      'dashboard.todoDeleteError': 'Aufgabe konnte nicht gelöscht werden',
      'dashboard.noTodos': 'Keine Aufgaben zum Anzeigen',
      'dashboard.todoPrompt': 'Neue Aufgabe eingeben:',
      'dashboard.addNewTodo': 'Neue Aufgabe hinzufügen',
      'dashboard.addTodoForDate': 'Aufgabe hinzufügen für {{date}}',
      'dashboard.todoTitlePlaceholder': 'Aufgabentitel',
      'dashboard.todoDescriptionPlaceholder': 'Beschreibung',
      'dashboard.markCompleted': 'Als erledigt markieren',
      'dashboard.todoUpdated': 'Aufgabe aktualisiert',
      'dashboard.todayReminderTitle': 'Heutige Aufgaben',
      'dashboard.todayReminderCount': '{{count}} Aufgabe offen',
      'dashboard.todayReminderCount_plural': '{{count}} Aufgaben offen',
      'dashboard.todayReminderAllDone': 'Alle Aufgaben für heute sind erledigt',
      'dashboard.todayReminderMore': '+{{count}} mehr',
      'dashboard.detail': 'Details',
      'dashboard.noCriticalContracts': 'Noch keine Verträge',
      'dashboard.daysLeftCount': '{{count}} Tag',
      'dashboard.daysLeftCount_plural': '{{count}} Tage',
      
      // Customers
      'customers.title': 'Kunden',
      'customers.totalCount': '{{count}} Kunden registriert',
      'customers.addNew': 'Neuer Kunde',
      'customers.stats.total': 'Kunden gesamt',
      'customers.stats.withActiveContract': 'Mit aktivem Vertrag',
      'customers.stats.withoutContract': 'Ohne Vertrag',
      'customers.stats.newThisMonth': 'Diesen Monat neu',
      'customers.stats.byCompany': 'Verträge nach Firma',
      'customers.stats.byType': 'Verträge nach Vertragstyp',
      'customers.stats.activeContractsNote': 'Anzahl aktiver Verträge',
      'customers.stats.empty': 'Noch keine Verträge',
      'customers.stats.showAll': 'Alle anzeigen (+{{count}})',
      'customers.stats.showLess': 'Weniger anzeigen',
      'customers.firstName': 'Vorname',
      'customers.lastName': 'Nachname',
      'customers.email': 'E-Mail',
      'customers.phone': 'Telefon',
      'customers.address': 'Adresse',
      'customers.company': 'Firma',
      'customers.search': 'Kunden suchen...',
      'customers.noCustomers': 'Noch keine Kunden',
      'customers.contracts': 'Verträge',
      'customers.noEmail': 'Keine E-Mail',
      'customers.noPhone': 'Kein Telefon',
      'customers.deleteTitle': 'Sind Sie sicher?',
      'customers.deleteConfirmIntro': 'Sind Sie sicher, dass Sie den Kunden ',
      'customers.deleteConfirmWith': ' zusammen mit seinen ',
      'customers.deleteConfirmContracts': ' Verträgen löschen möchten?',
      'customers.firstNameRequired': 'Vorname ist erforderlich',
      'customers.lastNameRequired': 'Nachname ist erforderlich',
      'customers.birthDateRequired': 'Geburtsdatum ist erforderlich',
      'customers.addressRequired': 'Adresse ist erforderlich',
      'customers.zipCodeRequired': 'Postleitzahl ist erforderlich',
      'customers.zipCodeNumeric': 'Postleitzahl darf nur Zahlen enthalten',
      'customers.invalidEmail': 'Bitte eine gültige E-Mail eingeben',
      'customers.invalidPhone': 'Telefonnummer muss mit „+“ und Landesvorwahl beginnen (z.B. +49 …)',
      'customers.emailRequired': 'E-Mail ist erforderlich (oder „Keine E-Mail“ aktivieren)',
      'customers.phoneRequired': 'Telefon ist erforderlich (oder „Keine Telefonnummer“ aktivieren)',
      'customers.loadError': 'Fehler beim Laden der Kunden',
      'customers.addSuccess': 'Kunde erfolgreich hinzugefügt',
      'customers.updateSuccess': 'Kunde erfolgreich aktualisiert',
      'customers.deleteSuccess': 'Kunde erfolgreich gelöscht',
      'customers.deleteError': 'Fehler beim Löschen des Kunden',

      // Contracts
      'contracts.title': 'Verträge',
      'contracts.manage': 'Verträge verwalten',
      'contracts.recordsFound': '{{count}} Datensätze gefunden',
      'contracts.totalRecords': 'Insgesamt {{count}} Datensätze',
      'contracts.showRecords': 'Datensätze anzeigen',
      'contracts.perPage': 'Pro Seite',
      'contracts.prev': 'Zurück',
      'contracts.next': 'Weiter',
      'contracts.includeExpired': 'Einschließlich beendeter Verträge',
      'contracts.showExtended': 'Verlängerte Verträge anzeigen',
      'contracts.print': 'Drucken',
      'contracts.days': 'Tage',
      'contracts.overdue': '{{days}} Tage überfällig',
      'contracts.addContract': 'Vertrag hinzufügen',
      'contracts.clearFilter': 'Filter zurücksetzen',
      'contracts.info': 'Info',
      'contracts.detailTitle': 'Vertragsdetails',
      'contracts.detailLoadError': 'Vertragsdetails konnten nicht geladen werden',
      'contracts.history': 'Vertragsverlauf',
      'contracts.noHistory': 'Keine Verlängerungsinformationen für den Vertrag gefunden.',
      'contracts.contractFiles': 'Vertragsdateien',
      'contracts.selectContractType': 'Wählen Sie zuerst einen Vertragstyp',
      'contracts.selectCompanyLabel': 'Firma auswählen',
      'contracts.extendDate': 'Vertragsenddatum verlängern',
      'contracts.6months': '+6 Monate',
      'contracts.1year': '+1 Jahr',
      'contracts.2years': '+2 Jahre',
      'contracts.contractNoPlaceholder': 'Vertragsnr. nicht eingegeben',
      'contracts.descriptionOptional': 'Beschreibung (Optional)',
      'contracts.removeFile': 'Datei entfernen',
      'contracts.update': 'Aktualisieren',
      'contracts.close': 'Schließen',
      'contracts.deleteConfirm': 'Sind Sie sicher, dass Sie diesen Vertrag löschen möchten?',
      'contracts.deleteSuccess': 'Vertrag gelöscht',
      'contracts.deleteError': 'Vertrag konnte nicht gelöscht werden',
      'contracts.loadError': 'Fehler beim Laden der Daten',
      'contracts.exportSuccess': 'Datei heruntergeladen',
      'contracts.exportError': 'Export fehlgeschlagen',
      'contracts.addNew': 'Neuer Vertrag',
      'contracts.contractTitle': 'Vertragstitel',
      'contracts.description': 'Beschreibung',
      'contracts.startDate': 'Startdatum',
      'contracts.endDate': 'Enddatum',
      'contracts.value': 'Wert',
      'contracts.status': 'Status',
      'contracts.customer': 'Kunde',
      'contracts.company': 'Firma',
      'contracts.type': 'Vertragstyp',
      'contracts.files': 'Dateien',
      'contracts.uploadFile': 'Datei hochladen',
      'contracts.export': 'Exportieren',
      'contracts.filter': 'Filtern',
      'contracts.search': 'Verträge suchen...',
      'contracts.noContracts': 'Noch keine Verträge',
      'contracts.active': 'Aktiv',
      'contracts.expired': 'Abgelaufen',
      'contracts.finishedContract': 'Abgelaufener Vertrag',
      'contracts.extensionMonths': '{{count}} Monat',
      'contracts.extensionMonths_plural': '{{count}} Monate',
      'contracts.extensionYears': '{{count}} Jahr',
      'contracts.extensionYears_plural': '{{count}} Jahre',
      'contracts.cancelled': 'Storniert',
      'contracts.daysRemaining': 'Verbleibende Tage',
      'contracts.orderNo': 'Bestell-Nr.',
      'contracts.orderNumberExists': 'Diese Bestellnummer existiert bereits',
      'contracts.contractNo': 'Vertrags-Nr.',
      'contracts.contractNumberExists': 'Diese Vertragsnummer existiert bereits',
      'contracts.deleteModalTitle': 'Sind Sie sicher?',
      'contracts.deleteModalMessage': 'Sind Sie sicher, dass Sie diesen Vertrag löschen möchten: ',
      'contracts.editTitle': 'Vertragsinformationen aktualisieren',
      'contracts.filesOptional': 'Vertragsdateien (Optional)',
      'contracts.noFilesUploaded': 'Keine Dateien hochgeladen',
      'contract.orderNo': 'Bestell-Nr.',
      'contract.contractNo': 'Vertrags-Nr.',
      'contract.dragDrop': 'Dateien hierher ziehen oder klicken, um sie hochzuladen.',
      'contract.supportedFormats': '(Unterstützte Formate: Excel, Word, Bilder und PDF)',
      'contract.maxSize': '(Maximale Dateigröße: 256 MB.)',
      
      // Wizard steps
      'wizard.step1': 'Kunde auswählen',
      'wizard.step2': 'Vertragsdetails',
      'wizard.step3': 'Dateien hochladen',
      'wizard.next': 'Weiter',
      'wizard.prev': 'Zurück',
      'wizard.finish': 'Fertigstellen',
      'wizard.selectCustomer': 'Kunde auswählen oder neu hinzufügen',
      'wizard.addNewCustomer': 'Neuen Kunden hinzufügen',
      'wizard.duration': 'Dauer',
      'wizard.6months': '+6 Monate',
      'wizard.1year': '+1 Jahr',
      'wizard.2years': '+2 Jahre',
      'wizard.back': 'Zurück',
      'wizard.send': 'Absenden',
      'wizard.cancel': 'Abbrechen',
      'wizard.fillRequiredFields': 'Bitte füllen Sie die erforderlichen Felder aus',
      
      // Companies
      'companies.title': 'Firmen',
      'companies.addNew': 'Neue Firma',
      'companies.name': 'Firmenname',
      'companies.address': 'Adresse',
      'companies.phone': 'Telefon',
      'companies.email': 'E-Mail',
      
      // Contract Types
      'contractTypes.title': 'Vertragstypen',
      'contractTypes.addNew': 'Neuer Typ',
      'contractTypes.name': 'Typ Name',
      'contractTypes.description': 'Beschreibung',
      
      // Common
      'common.save': 'Speichern',
      'common.cancel': 'Abbrechen',
      'common.delete': 'Löschen',
      'common.edit': 'Bearbeiten',
      'common.view': 'Ansehen',
      'common.update': 'Aktualisieren',
      'common.actions': 'Aktionen',
      'common.loading': 'Laden...',
      'common.error': 'Fehler',
      'common.success': 'Erfolg',
      'common.confirm': 'Bestätigen',
      'common.close': 'Schließen',
      'common.add': 'Hinzufügen',
      // Settings (generic)
      'settings.subtitle': 'Firmen und Vertragstypen verwalten',
      'settings.loadError': 'Fehler beim Laden der Daten',
      'settings.operationFailed': 'Vorgang fehlgeschlagen',
      'settings.confirmDeleteCompany': 'Möchten Sie diese Firma wirklich löschen?',
      'settings.confirmDeleteContractType': 'Möchten Sie diesen Vertragstyp wirklich löschen?',
      'settings.companyUpdated': 'Firma aktualisiert',
      'settings.companyAdded': 'Firma hinzugefügt',
      'settings.companyDeleted': 'Firma gelöscht',
      'settings.companyDeleteError': 'Firma konnte nicht gelöscht werden',
      'settings.contractTypeUpdated': 'Vertragstyp aktualisiert',
      'settings.contractTypeAdded': 'Vertragstyp hinzugefügt',
      'settings.contractTypeDeleted': 'Vertragstyp gelöscht',
      'settings.contractTypeDeleteError': 'Vertragstyp konnte nicht gelöscht werden',
      'settings.companiesTab': 'Firmen',
      'settings.contractTypesTab': 'Vertragstypen',
      'settings.newCompany': 'Neue Firma',
      'settings.addNewType': 'Neuen Typ hinzufügen',
      'settings.addNewCompany': 'Neue Firma hinzufügen',
      'settings.addNewContractType': 'Neuen Vertragstyp hinzufügen',
      'settings.editCompany': 'Firma bearbeiten',
      'settings.editContractType': 'Vertragstyp bearbeiten',
      'settings.companyName': 'Firmenname',
      'settings.email': 'E-Mail',
      'settings.phone': 'Telefon',
      'settings.address': 'Adresse',
      'settings.actions': 'Aktionen',
      'settings.typeName': 'Typname',
      'settings.contractTypeName': 'Vertragstypname',
      'settings.description': 'Beschreibung',
      'settings.noCompaniesYet': 'Noch keine Firmen',
      'settings.noContractTypesYet': 'Noch keine Vertragstypen',
      'settings.searchPlaceholder': 'Suchen...',
      'settings.id': 'Id',
      'settings.contractType': 'Vertragstyp',
      'settings.contractCount': 'Anzahl Verträge',
      'settings.noRecordsYet': 'Noch keine Einträge',
      'settings.active': 'Aktiv',
      'settings.selectCompany': 'Firma auswählen',
      'settings.selectCompanyPlaceholder': 'Firma auswählen',
      'settings.selectContractType': 'Vertragstyp auswählen',
      'settings.noContractTypesFound': 'Keine Vertragstypen gefunden',
      'settings.newCompanyNamePlaceholder': 'Neuer Firmenname',
      'settings.newContractTypeNamePlaceholder': 'Neuer Vertragstypname',
      'settings.contractTypeRequired': 'Vertragstyp ist erforderlich',
      'settings.contractSettingsTitle': 'Vertragseinstellungen',
      'settings.contractSettingsTotalRows': 'Insgesamt {{count}} Zeilen',

      // Application Settings
      'appSettings.title': 'Anwendungseinstellungen',
      'appSettings.subtitle': 'Allgemeine Anwendungseinstellungen',
      'appSettings.loadError': 'Einstellungen konnten nicht geladen werden',
      'appSettings.saveSuccess': 'Einstellungen gespeichert',
      'appSettings.saveError': 'Einstellungen konnten nicht gespeichert werden',
      'appSettings.resetSuccess': 'Einstellungen auf Standard zurückgesetzt',
      'appSettings.resetError': 'Zurücksetzen fehlgeschlagen',
      'appSettings.backupDownloaded': 'Backup heruntergeladen',
      'appSettings.contractEndReminder': 'Vertragsende-Erinnerung',
      'appSettings.contractEndReminderOptions.one_day': 'E-Mail für Verträge senden, die in 1 Tag enden',
      'appSettings.contractEndReminderOptions.one_week': 'E-Mail für Verträge senden, die in 1 Woche enden',
      'appSettings.contractEndReminderOptions.one_month': 'E-Mail für Verträge senden, die in 1 Monat enden',
      'appSettings.contractEndReminderOptions.three_months': 'E-Mail für Verträge senden, die in 3 Monaten enden',
      'appSettings.contractEndReminderOptions.six_months': 'E-Mail für Verträge senden, die in 6 Monaten enden',
      'appSettings.contractEndReminderOptions.one_year': 'E-Mail für Verträge senden, die in 1 Jahr enden',
      'appSettings.reminderEmailPeriod': 'Erinnerungs-E-Mail-Intervall',
      'appSettings.backupEmailPeriod': 'Backup-E-Mail-Intervall',
      'appSettings.periodOptions.daily': 'Einmal am Tag',
      'appSettings.periodOptions.weekly': 'Einmal pro Woche',
      'appSettings.periodOptions.monthly': 'Einmal im Monat',
      'appSettings.periodOptions.quarterly': 'Einmal alle 3 Monate',
      'appSettings.periodOptions.half_yearly': 'Einmal alle 6 Monate',
      'appSettings.periodOptions.yearly': 'Einmal im Jahr',
      'appSettings.email': 'E-Mail',
      'appSettings.emailPlaceholder': 'info@contractmanager.com',
      'appSettings.email2': 'Zweite E-Mail (optional)',
      'appSettings.email2Placeholder': 'zweite@email.com',
      'appSettings.sidebar': 'Seitenleiste',
      'appSettings.sidebarOptions.modern': 'Modern',
      'appSettings.sidebarOptions.classic': 'Klassisch',
      'appSettings.sidebarOptions.minimal': 'Minimal',
      'appSettings.themeColorLight': 'Themenfarbe (Hellmodus)',
      'appSettings.themeColorDark': 'Themenfarbe (Dunkelmodus)',
      'appSettings.resetDefaults': 'Auf Standard zurücksetzen',
      'appSettings.saveChanges': 'Änderungen speichern',
      'appSettings.downloadBackup': 'Backup herunterladen',
      'appSettings.downloadBackupDescription': 'Exportieren Sie Ihre Einstellungen und Daten als Backup-Datei',
      'appSettings.download': 'Herunterladen',
      'appSettings.includeContractFiles': 'Vertragsdateien ebenfalls herunterladen (PDF)',
      'appSettings.backupPreparing': 'Backup wird vorbereitet, bitte warten… (Dateien werden gezippt)',
      'appSettings.backupDownloading': 'Wird heruntergeladen',
      'common.details': 'Details',
      'common.all': 'Alle',
      'common.today': 'Heute',
      
      // Todos
      'todos.placeholder': 'Neue Aufgabe hinzufügen...',
      'todos.empty': 'Keine Aufgaben',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: (typeof window !== 'undefined' && (localStorage.getItem('appLanguage') || localStorage.getItem('i18nextLng'))) || 'de',
    fallbackLng: ['de', 'en'],
    interpolation: {
      escapeValue: false
    }
  });

// Persist language selection
if (typeof window !== 'undefined') {
  i18n.on('languageChanged', (lng) => {
    try {
      localStorage.setItem('appLanguage', lng);
    } catch {
      // ignore
    }
  });
}

export default i18n;
